"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _theme = require("../theme");

var _mixins = require("../utils/mixins");

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var getKeyframes = function getKeyframes() {
  var _ref;

  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return _ref = {}, (0, _defineProperty2.default)(_ref, "".concat(delay, "%"), {
    transform: 'scale(1) translate3d(0, 0, 0)'
  }), (0, _defineProperty2.default)(_ref, "".concat(20 + delay, "%"), {
    transform: 'scale(1) translate3d(0, 100%, 0)'
  }), (0, _defineProperty2.default)(_ref, "".concat(80 + delay, "%"), {
    transform: 'scale(1) translate3d(0, 0, 0)'
  }), _ref;
};

var styles = function styles(theme) {
  return {
    '@keyframes ruiAnimateDot1': getKeyframes(),
    '@keyframes ruiAnimateDot2': getKeyframes(100 / (600 / 80)),
    '@keyframes ruiAnimateDot3': getKeyframes(100 / (600 / 160)),
    spinner: {
      extend: [_mixins.isolateMixin, _mixins.middleMixin],
      display: 'inline-block',
      color: theme.spinner.color,
      verticalAlign: 'middle',
      pointerEvents: 'none',
      fontSize: 5,
      whiteSpace: 'nowrap'
    },
    position: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      textAlign: 'center'
    },
    dot: {
      display: 'inline-block',
      verticalAlign: 'middle',
      height: '1em',
      width: '1em',
      position: 'relative',
      top: "-".concat(2 / 5, "em"),
      borderRadius: '50%',
      color: 'inherit!important',
      background: 'currentColor',
      transition: 'transform .6s ease-out',
      transform: 'translate3d(0, 0, 0)',
      animation: '.6s ease-out',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      '&:nth-child(1)': {
        animationName: '$ruiAnimateDot1'
      },
      '&:nth-child(2)': {
        animationName: '$ruiAnimateDot2',
        margin: '0 1em'
      },
      '&:nth-child(3)': {
        animationName: '$ruiAnimateDot3'
      }
    }
  };
};

var Spinner = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Spinner, _PureComponent);

  var _super = _createSuper(Spinner);

  function Spinner() {
    (0, _classCallCheck2.default)(this, Spinner);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Spinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          color = _this$props.color,
          size = _this$props.size,
          inline = _this$props.inline,
          classes = _this$props.classes;
      var resultStyle = (0, _extends2.default)({
        fontSize: size,
        color: color
      }, style);

      var dot = _react.default.createElement("span", {
        className: classes.dot
      });

      return _react.default.createElement("span", {
        style: resultStyle,
        className: (0, _classnames.default)(className, classes.spinner, !inline && classes.position)
      }, dot, dot, dot);
    }
  }]);
  return Spinner;
}(_react.PureComponent);

Spinner.defaultProps = {
  inline: false
};
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * CSS-класс
   */
  className: _propTypes.default.string,

  /**
   * Inline-стили
   */
  style: _propTypes.default.object,

  /**
   * Цвет точек
   */
  color: _propTypes.default.string,

  /**
   * Размер точек
   */
  size: _propTypes.default.number,

  /**
   * Сделать строчным элементом
   */
  inline: _propTypes.default.bool
} : {};

var _default = (0, _theme.withStyles)(styles, {
  name: 'Spinner'
})(Spinner);

exports.default = _default;